import { configureStore } from "@reduxjs/toolkit"
import axiosReducer from "./slices/axios-slice"

export const store = configureStore({
  reducer: {
    axios: axiosReducer,
  }
})